import { CommandsBase } from './base';

export namespace Tasks {
  export namespace Types {
    export interface AssignProps {
      userEmail: string;
      taskIds: number[];
    }
    export interface AssignData {
      succeeded: {
        taskIds: string[];
        userId: string;
      };
      failed: {
        taskIds: { taskId: string; message: string }[];
        userId: string;
      }[];
    }

    export interface ListProps {
      userId?: string;
      status?: string;
      offset?: number;
      limit?: number;
    }

    export interface Task {
      id: string;
      userId: string;
      boardId: string;
      description: string;
    }

    export type ListTasksData = Task[];

    export interface LoadDistributionTasksByUserIdResponseItem {
      id: string;
      userId: string;
    }
    export type UserTasksData = LoadDistributionTasksByUserIdResponseItem[];

    export interface ByUserProps {
      userId: string; // actually email
    }
  }

  export const SERVICE = 'tasks';
  export const ACTIONS = {
    assign: 'assign',
    getForUser: 'getForUser',
    list: 'list',
  };
  export const EVENTS = {};

  export class Commands extends CommandsBase {
    assign(props: Types.AssignProps) {
      return this.client.execute<typeof props, Types.AssignData>(
        this.command(ACTIONS.assign),
        props
      );
    }

    listByUser(props: Types.ByUserProps) {
      return this.client.execute<typeof props, Types.UserTasksData>(
        this.command(ACTIONS.getForUser),
        props
      );
    }

    list(props: Types.ListProps = {}) {
      return this.client.execute<typeof props, Types.ListTasksData>(
        this.command(ACTIONS.list),
        props
      );
    }
  }
}
